import { Action } from 'redux';
import { Dispatch } from 'react-redux';
import { AppState } from 'src';

export interface OptionsViewModel {
  id: number;
  order?: string;
  value: string;
}

export interface Owner {
  id: number;
  firstName: string;
  lastName: string;
  username?: string;
}

export interface AddressViewModel {
  isValidated?: boolean;
  international?: boolean;
  id: number;
  line1: string;
  line2?: string;
  city: string;
  state: StatesViewModel;
  country?: string;
  primary?: boolean;
  zip: string;
}

export var blankOptionsVM = {
  id: -1,
  value: ''
} as OptionsViewModel;

export var blankStatesVM = {
  id: 0,
  name: '',
  abbreviation: ''
} as StatesViewModel;

export var blankAddressVM = {
  id: 0,
  line1: '',
  city: '',
  state: blankStatesVM,
  zip: '',
  isValidated: false,
  international: false,
  primary: false
} as AddressViewModel;

export interface PageViewModel<SearchType> {
  totalResults: number;
  page: number;
  pageSize: number;
  results: SearchType[];
  filterBy?: string;
}

export interface OfficeSearchViewModel {
  id: number;
  name: string;
  phone: string;
  city: string;
  address: string;
}

// export interface CommentViewModel {
//     commentId: number;
//     entityId: number;
//     comment: string;
//     commentType: string;
//     employee: OptionsViewModel;
//     addedDate: Date;
// }

export enum PropertyTypes {
  SingleFamily = 1,
  Duplex = 2,
  Triplex = 3,
  FourPlex = 4,
  FiveToSixK = 5,
  SixToSevenK = 6,
  SevenToEightK = 7,
  EightToNineK = 8,
  NineToTenK = 9,
  Condo = 10,
  MobileHome = 15,
  MultiUnit = 17,
  GuestHouse = 21,
  Guest750Plus = 22,
  FivePlex = 45,
  SixPlex = 46,
  SevenPlex = 47,
  EightPlex = 48,
  Over10K = 50,
  FiveToTenK = 55,
  Commercial = 101
}

export interface StatesViewModel {
  id: number;
  name: string;
  abbreviation: string;
}

export interface JWTViewModel {
  jwt: string;
}

export interface AddressValidationModel {
  addressId: number;
  accountId: number;
  accountTypeCd: number;
  addressLine1Ds: string;
  addressLine2Ds: string;
  cityNm: string;
  stateAbbrNm: string;
  zipAn: string;
  zip4An: string;
  dp2: string;
  dpc: string;
  countyAn: string;
  dtmStatusAn: string;
  primaryFl: {};
  foreignFl: {};
  accountTypeCdNavigation: {};
  state: {};
}

export interface ErrorAction<T> extends Action {
  readonly type: T;
  readonly errorMessage: string;
}

export interface Dictionary<T> {
  readonly [property: string]: T;
}

export interface EntitySimpleViewModel {
  readonly id: number;
  readonly name: string;
}
export type AppDispatcher = Dispatch<AppState>;



// WEBPACK FOOTER //
// ./src/_models/common.models.ts